import { useRef, useState } from "react";
import { Loader2, Upload } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const UploadButton = ({ onUploaded, testId, label = "Upload image" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/media", fd);
      onUploaded(data.url);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={onFile} data-testid={`${testId}-input`} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={testId} className="inline-flex items-center gap-2 rounded-full border border-maroon px-4 py-2 text-sm font-semibold text-maroon transition-colors hover:bg-maroon hover:text-ivory disabled:opacity-50">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} {label}
      </button>
    </>
  );
};
